import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import DownloadApp from "./components/DownloadApp";
import Newsletter from "./components/NewsLetter";
import Footer from "./components/Footer";

// Images for Header Carousel
import assoc1 from "../images/associate1.jpg";
import assoc2 from "../images/associate2.jpg";
import assoc3 from "../images/associate3.jpg";

// Unique images for the tab cards (Admission, Content, Exam, Admin)
import adm1 from "../images/aden1.png";
import adm2 from "../images/aden2.png";
import adm3 from "../images/aden3.png";
import adm4 from "../images/aden4.png";
import adm5 from "../images/aden5.png";

import cont1 from "../images/content1.png";
import cont2 from "../images/content2.png";
import cont3 from "../images/content3.png";
import cont4 from "../images/content4.png";
import cont5 from "../images/content5.png";

import exam1 from "../images/exam1.png";
import exam2 from "../images/exam2.png";
import exam3 from "../images/exam3.png";
import exam4 from "../images/exam4.png";
import exam5 from "../images/exam5.png";

import admin1 from "../images/admin1.png";
import admin2 from "../images/admin2.png";
import admin3 from "../images/admin3.png";
import admin4 from "../images/admin4.png";
import admin5 from "../images/admin5.png";

import circlesBg from "../images/Banner2.png";

import "./css/Associates.css";

function Associates() {
    const images = [assoc1, assoc2, assoc3];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeTab, setActiveTab] = useState("admission");

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3500);
        return () => clearInterval(timer);
    }, [images.length]);

    const getPrevIndex = (index) => (index - 1 + images.length) % images.length;
    const getNextIndex = (index) => (index + 1) % images.length;

    // Data for the 4 tabs with unique images and 5 cards per tab
    const tabData = {
        admission: [
            {
                title: "Admission Enquiry",
                desc: "Your future starts here",
                points: [
                    "Start your journey from any platform—mobile, desktop, or social media.",
                    "Designed to ensure a frictionless start to your process. Get your enquiry submitted in seconds!",
                    "Ensures your query is acknowledged immediately. You'll never be left waiting.",
                    "Experience a streamlined admissions pathway for fast, accurate follow-up from our team."
                ],
                img: adm1
            },
            {
                title: "Application Form",
                desc: "Simple & guided application",
                points: [
                    "Guided interface ensures 100% accuracy and completion.",
                    "Session management keeps your progress secured and instantly accessible from any device.",
                    "Secure document upload for all academic credentials.",
                    "Real-time status tracking of your application review."
                ],
                img: adm2
            },
            {
                title: "Interview Process",
                desc: "Transparent evaluation",
                points: [
                    "Seamlessly book and confirm your interview slot online.",
                    "A two-way conversation to ensure mutual fit.",
                    "Holistic evaluation of leadership, character, and skills.",
                    "Decision transparency with timely feedback and final notification."
                ],
                img: adm3
            },
            {
                title: "Fee Payment",
                desc: "Secure digital transactions",
                points: [
                    "Secure gateway processes all payments with maximum data security.",
                    "Flexible options let you choose from multiple payment modes.",
                    "Instant receipt generation upon successful completion.",
                    "Complete payment history available in your dashboard."
                ],
                img: adm4
            },
            {
                title: "Student Onboarding",
                desc: "Ready for your academic journey",
                points: [
                    "Personalized orientation kit and schedule available.",
                    "Digital credentialing with student ID and official Crestest email.",
                    "Community integration through student forums and peer programs.",
                    "Resource hub with schedule, fee ledger, and campus information."
                ],
                img: adm5
            }
        ],

        content: [
            {
                title: "Content Creation",
                desc: "Develop engaging learning resources",
                points: [
                    "Create content using rich media and academic formats.",
                    "Structured digital review by subject matter experts.",
                    "Centralized control over content permissions and usage.",
                    "Instant sharing to relevant student groups or standards."
                ],
                img: cont1
            },
            {
                title: "Content Library",
                desc: "Centralized resource management",
                points: [
                    "Tag content by subject, chapter, and standard.",
                    "Centralized, secure library for all approved resources.",
                    "Quick identification and redeployment of learning assets.",
                    "Powerful filters for fast, precise content retrieval."
                ],
                img: cont5
            },
            {
                title: "Media Streaming",
                desc: "Optimized digital delivery",
                points: [
                    "Automatic conversion for best playback quality on all devices.",
                    "Content protection from unauthorized download or sharing.",
                    "Adaptive streaming ensures performance across varied networks.",
                    "High-availability hosting for constant lecture access."
                ],
                img: cont2
            },
            {
                title: "Content Analytics",
                desc: "Track learning engagement",
                points: [
                    "Log student view time and content completion status.",
                    "Visual reporting on resource access and popularity.",
                    "Automated alerts for students with low content engagement.",
                    "Real-time metrics for resource effectiveness."
                ],
                img: cont3
            },
            {
                title: "Assignments",
                desc: "Digital submission & review",
                points: [
                    "Delegate tasks by chapter or individual student needs.",
                    "Secure portal for student assignment uploads.",
                    "Integrated tools ensure academic integrity.",
                    "Timely annotated reviews by teachers."
                ],
                img: cont4
            }
        ],

        exam: [
            {
                title: "Exam Scheduling",
                desc: "Manage examinations efficiently",
                points: [
                    "Unified view of all exam deadlines and time slots.",
                    "Automated flagging and resolution of scheduling clashes.",
                    "Precise control over exam duration and submission windows.",
                    "Automatic alerts to students, invigilators, and faculty."
                ],
                img: exam1
            },
            {
                title: "Question Bank",
                desc: "Smart paper preparation",
                points: [
                    "Draw questions based on weighted difficulty and topic.",
                    "Assign authorship while maintaining central oversight.",
                    "Create questions with text, images, and rich media.",
                    "Ensure uniformity across all subject question papers."
                ],
                img: exam2
            },
            {
                title: "Paper Review",
                desc: "Finalize examinations",
                points: [
                    "Instantly view final paper layout before publication.",
                    "Precisely define mark schemes and partial credit rules.",
                    "Log all edits and version changes for transparency.",
                    "Generate detailed internal paper versions with answer keys."
                ],
                img: exam3
            },
            {
                title: "Online Examination",
                desc: "Secure digital assessments",
                points: [
                    "Time-bound access verified by digital credentials.",
                    "Optional malpractice prevention features.",
                    "Continuous progress auto-save for minimal disruption.",
                    "Real-time status monitoring for invigilators."
                ],
                img: exam4
            },
            {
                title: "Evaluation",
                desc: "Accurate & efficient marking",
                points: [
                    "Instant evaluation of objective questions.",
                    "Anonymous marking for subjective answers.",
                    "Distribute answer sheets for parallel evaluation.",
                    "Digital scoring parameters for consistent assessment."
                ],
                img: exam5
            },
            // {
            //     title: "Results & Reports",
            //     desc: "Comprehensive performance insights",
            //     points: [
            //         "Publish official reports immediately to all portals.",
            //         "Performance breakdown by chapter, topic, and skill level.",
            //         "Compare current and historical performance.",
            //         "Permanent results stored in the student's academic ledger."
            //     ],
            //     img: exam6
            // }
        ],

        admin: [
            {
                title: "User Access Management",
                desc: "Secure administrative control",
                points: [
                    "Outline precise system access based on user designation.",
                    "Automatically customize dashboards per user function.",
                    "Streamline staff onboarding, modification, and offboarding.",
                    "Enforce strong security policies with multi-factor authentication."
                ],
                img: admin1
            },
            {
                title: "Task Management",
                desc: "Efficient administrative workflow",
                points: [
                    "Digitally delegate administrative duties to staff.",
                    "Built-in tools for internal alerts and secure coordination.",
                    "Automated transfer of high-priority or overdue tasks.",
                    "Distribute high-volume tasks across the team."
                ],
                img: admin2
            },
            {
                title: "System Operations",
                desc: "Automate daily administration",
                points: [
                    "Execute actions on large datasets simultaneously.",
                    "Centralized tools for creating and deploying digital forms.",
                    "Automate routine backup and archival processes.",
                    "Personalize administrative views and reports."
                ],
                img: admin3
            },
            {
                title: "Student Management",
                desc: "Complete student oversight",
                points: [
                    "Single view of academic, financial, and engagement data.",
                    "Instant access to scores and class standings.",
                    "Segment students by program or performance metrics.",
                    "Track portal activity and communication history."
                ],
                img: admin4
            },
            {
                title: "Data Security",
                desc: "Enterprise-grade protection",
                points: [
                    "Industry-standard encryption for sensitive data.",
                    "Comprehensive audit logs for every interaction.",
                    "Compliance with local and international privacy laws.",
                    "Automated backup and disaster recovery."
                ],
                img: admin5
            },
            // {
            //     title: "Monitoring & Reports",
            //     desc: "Platform insights",
            //     points: [
            //         "Generate tamper-proof administrative logs.",
            //         "Real-time visibility into platform performance and uptime.",
            //         "Create specialized reports with custom tools.",
            //         "Track all configuration updates and feature deployments."
            //     ],
            //     img: admin6
            // }
        ]
    };

    return (
        <div className="associates-page-wrapper">
            {/* Header with Navbar */}
            <header className="associates-header-section">
                <div className="associates-hero-container">
                    <Navbar />
                    <div className="container text-center py-3">
                        <span className="badge px-3 py-1 rounded-pill fw-bold mb-2" style={{ backgroundColor: '#FBBB1B', color: '#1e293b' }}>
                            Our Network & Partners
                        </span>
                        <h1 className="fw-bold text-white display-6 mb-2">Trusted Institutional Associates</h1>
                        <p className="text-white-50 mx-auto mb-4" style={{ maxWidth: '550px', fontSize: '0.95rem' }}>
                            Collaborating with leading schools, institutions, and educational networks across the nation to drive academic transformation.
                        </p>

                        {/* Circular Overlapping Image Carousel Animation */}
                        <div className="associates-carousel-stage">
                            <div className="associates-carousel-track">
                                <div className="assoc-card side-card left-card">
                                    <img src={images[getPrevIndex(currentIndex)]} alt="Previous Associate" className="img-fluid rounded-4 shadow" />
                                </div>
                                <div className="assoc-card center-card shadow-lg">
                                    <img src={images[currentIndex]} alt="Current Featured Associate" className="img-fluid rounded-4" />
                                </div>
                                <div className="assoc-card side-card right-card">
                                    <img src={images[getNextIndex(currentIndex)]} alt="Next Associate" className="img-fluid rounded-4 shadow" />
                                </div>
                            </div>
                            <div className="carousel-dots mt-3">
                                {images.map((_, idx) => (
                                    <button
                                        key={idx}
                                        className={`dot-indicator ${currentIndex === idx ? 'active' : ''}`}
                                        onClick={() => setCurrentIndex(idx)}
                                        aria-label={`Slide ${idx + 1}`}
                                    ></button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content Info Container */}
            <main className="container my-5 py-4">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="card shadow-sm border-0 rounded-4 p-4 p-md-5 text-center bg-white">
                            <h2 className="fw-bold mb-4" style={{ color: '#207AB4' }}>Empowering Education Together</h2>
                            <p className="text-muted lh-lg fs-6 mb-0">
                                Passionate about advancing online education, Crestest Learning Portal empowers students and transforms learning environments - an inevitable shift in today's education system. Our inclusive solution, featuring the Comprehensive Digital Learning Suite, is designed for collaboration. We partner with educational institutions to maximize our societal impact.
                            </p>
                        </div>
                    </div>
                </div>
            </main>

            {/* Download App Section */}
            <DownloadApp />

            {/* Light Background Section with 3 Cards per Row Layout */}
            <section className="position-relative py-5 text-dark bg-light-section" style={{ backgroundImage: `url(${circlesBg})` }}>
                <div className="container text-center py-4 position-relative z-2">
                    <span className="badge px-3 py-1 rounded-pill fw-bold mb-2 shadow-sm" style={{ backgroundColor: '#207AB4', color: '#ffffff' }}>
                        Ecosystem Overview
                    </span>
                    <h2 className="fw-bold display-6 mb-3" style={{ color: '#207AB4' }}>Comprehensive Institutional Support</h2>
                    <p className="text-muted mx-auto mb-5" style={{ maxWidth: '650px' }}>
                        Explore our multi-faceted modules built specifically to streamline campus operations and elevate learning outcomes.
                    </p>

                    {/* 4 Tabs Navigation (Updated for light background) */}
                    <div className="d-flex justify-content-center flex-wrap gap-2 mb-5">
                        {[
                            { key: 'admission', label: 'Admission' },
                            { key: 'content', label: 'Content' },
                            { key: 'exam', label: 'Exam' },
                            { key: 'admin', label: 'Admin' }
                        ].map((tab) => (
                            <button
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                className={`btn px-4 py-2 rounded-pill fw-bold transition-all ${activeTab === tab.key ? 'shadow' : ''}`}
                                style={{
                                    backgroundColor: activeTab === tab.key ? '#207AB4' : '#ffffff',
                                    color: activeTab === tab.key ? '#ffffff' : '#207AB4',
                                    border: '1px solid #207AB4'
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* 3 Cards per Row layout for larger cards and better readability */}
                    <div className="row g-4 justify-content-center">
                        {tabData[activeTab].map((card, idx) => (
                            <div className="col-lg-4 col-md-6" key={idx}>
                                <div className="card h-100 border-0 rounded-4 shadow-sm bg-white text-dark p-4 text-start">
                                    <div className="card-img-wrapper mb-3 overflow-hidden rounded-3 shadow-sm" style={{ height: '180px' }}>
                                        <img src={card.img} alt={card.title} className="w-100 h-100 object-fit-cover" />
                                    </div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#207AB4' }}>{card.title}</h5>
                                    <p className="text-muted small mb-3">{card.desc}</p>
                                    <ul className="list-unstyled mb-0 small text-secondary">
                                        {card.points.map((pt, pIdx) => (
                                            <li key={pIdx} className="mb-2 d-flex align-items-center">
                                                <span className="me-2 fw-bold" style={{ color: '#FBBB1B' }}>•</span> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Newsletter Section */}
            <Newsletter />

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default Associates;